export default "__VITE_ASSET__DpiW89jy__"